/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WorkatoIntegration = "HiBob" | "%future added value";
export type StopRecipesInput = {
    integration?: WorkatoIntegration | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type stopRecipesMutationVariables = {
    input: StopRecipesInput;
};
export type stopRecipesMutationResponse = {
    readonly stopRecipes: {
        readonly outcome: string | null;
    } | null;
};
export type stopRecipesMutation = {
    readonly response: stopRecipesMutationResponse;
    readonly variables: stopRecipesMutationVariables;
};



/*
mutation stopRecipesMutation(
  $input: StopRecipesInput!
) {
  stopRecipes(input: $input) {
    outcome
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "StopRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopRecipesPayload",
    "kind": "LinkedField",
    "name": "stopRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "stopRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation stopRecipesMutation(\n  $input: StopRecipesInput!\n) {\n  stopRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
(node as any).hash = '7d0b170724681343bb6d4ac9e0ee3426';
export default node;
